import { useState, useEffect, useMemo } from 'react';
import OrderService from '../../services/orderService.js';
import { stateService } from '../../utils/stateService.js';

export const useFetchCampaignData = (orderline, customerId, countryCode) => {
    if (!orderline) return { loading: false, data: null, error: null };

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const orderService = useMemo(() => new OrderService(), []);

    useEffect(() => {
        let isMounted = true;
        const fetchData = async () => {
            try {
                // Log current orderline being processed
                //console.log('Fetching data for orderline:', orderline.id);

                // Check cache first
                const cachedData = stateService.getItem(orderline.id);
                //console.log('Cache result for orderline', orderline.id, ':', cachedData);

                if (cachedData) {
                    if (isMounted) {
                        //console.log('Using cached data for orderline:', orderline.id);
                        setData(cachedData);
                        setLoading(false);
                    }
                    return;
                }

                // Fetch from API if not in cache
                const fetchFromApi = () => {
                    return new Promise((resolve, reject) => {
                        orderService.getOrderLines(
                            customerId,
                            [orderline],
                            null,
                            null,
                            countryCode,
                            (responseData) => {
                                //console.log('API response for orderline', orderline.id, ':', responseData);
                                resolve(responseData);
                            },
                            reject
                        );
                    });
                };

                const apiData = await fetchFromApi();
                if (isMounted) {
                    stateService.setState(orderline.id, null);
                    stateService.setState(orderline.id, apiData);

                    const verifyCache = stateService.getItem(orderline.id);
                    //console.log('Verify cache for orderline', orderline.id, ':', verifyCache);

                    setData(apiData);
                    setLoading(false);
                }
            } catch (err) {
                console.error("Error fetching campaign data for orderline", orderline.id, ":", err);
                if (isMounted) {
                    setError(err);
                    setLoading(false);
                }
            }
        };

        fetchData();
        return () => {
            isMounted = false;
        };
    }, [orderline.id, customerId, countryCode, orderService]);

    return { loading, data, error };
};